var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=' <div class="col-1 col-sm-3 col-md-4 col-lg-5 col-xl-6">   <div class="" style="text-align: center"> <div class=""> <div class="" style="text-align: center"> <img style="height:100%; width:100%" alt="" src="'+
((__t=( model.WebpageImageUrl ))==null?'':__t)+
'"> </div> </div> <div class=""> <div style="height:10px"></div> <div class="" style="text-align: center"> <img style="min-width:150px;min-height:150px;max-width:150px;max-height:150px" alt="" src="'+
((__t=( model.QRCodeImageUrl ))==null?'':__t)+
'"> </div> </div> <div class=""> <p class="name" style="overflow: hidden; text-overflow: ellipsis; text-align: center; margin-top:5px; margin-bottom:5px; min-height:40px;max-height:40px">'+
((__t=( model.EventName ))==null?'':__t)+
'</p> </div> <div class=""> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItem_btnDetails">'+
((__t=( resources['X100273'] ))==null?'':__t)+
'</button> </div> <div class="" style="height:30px"></div> </div>   </div> ';
}
return __p;
};
